export default "__VITE_ASSET__efb7d3b9__"